import { createContext } from "react";

import { IFilterData } from "../components/admin/Partners/components/DesktopPartners";
import { IOffersFilterData } from "../components/admin/Offers/components/Desktop";
import { initialFilterData } from "../components/admin/Reports/WebhooksReport/components/DesktopReport";
import { initialFilterData as initialCreativesReportFilterData } from "../components/admin/Reports/CreativeReport/components/DesktopReport";
import { initialSummaryReportFilterData } from "../components/admin/Reports/SummaryReportV2/components/DesktopReport";
import { initialSummaryReportFilterData as initialAffSummaryReportFilterData } from "../components/affiliate/Reports/SummaryReportV2/components/DesktopReport";
import { initialAgentStatReportFilterData } from "../components/admin/Reports/AgentStatisticsReport/components/DesktopReport";
import { initialCashierStatReportFilterData } from "../components/admin/Reports/CashierStatisticsReport/components/DesktopReport";
import { initialAgentStatReportFilterData as initialAgStatReportFilterData } from "../components/agent/Reports/AgentStatisticsReport/components/DesktopReport";
import { IWebhookReportFilterData } from "../components/admin/Reports/WebhooksReport/types";
import { IFilterFields } from "../components/admin/Reports/Finance_report/components/Details";
import { IFilterFields as IFilterFieldsFinance} from "../components/admin/Reports/Finance_report/";
import { ICreativesReportFilterData } from "../components/admin/Reports/CreativeReport/types";
import { ISummaryReportFilterDataType } from "../components/admin/Reports/SummaryReportV2/types";
import { ISummaryReportFilterDataType as IAffSummaryReportFilterDataType } from "../components/affiliate/Reports/SummaryReportV2/types";
import {IDashboardFilterType} from "../components/common/DashboardV2/types";
import { initialDashboardV2FilterData } from "../components/common/DashboardV2";
import { IDealsFilterData } from "../components/admin/Deals/components/DesktopDeals";
import { IEmployeesFilterData } from "../components/admin/Employees/components/DesktopReport";
import { initialFilterData as initialEmployeesFilterData } from "../components/admin/Employees/components/DesktopReport";
import { IAgentsListFilterData } from "../components/admin/Agents/AgentsList";
import { IAgntPlayersListFilterData } from "../components/agent/PlayerList";
import { IAgntAgentsListFilterData } from "../components/agent/AgentList";
import { IAgentStatReportFilterDataType } from "../components/admin/Reports/AgentStatisticsReport/types";
import { ICashierStatReportFilterDataType } from "../components/admin/Reports/CashierStatisticsReport/types";
import { IAgentStatReportFilterDataType as IAgStatReportFilterDataType } from "../components/agent/Reports/AgentStatisticsReport/types";
import { ITransactionsFilterData as IAgntTransactionsFilterData } from "../components/agent/TransactionsHistory";
import { IWithdrawalFilterData } from "../components/cashier/WithdrawalList";
import { ITransfersFilterData as IAgntTransfersFilterData } from "../components/agent/TransfersHistory";
import { ITransactionsFilterData as IAdmTransactionsFilterData } from "../components/admin/Agents/TransactionsHistory";
import { ITransfersFilterData as IAdmTransfersFilterData } from "../components/admin/Agents/TransfersHistory";
import { IAgentsFullListFilterData } from "../components/admin/Agents/FullAgentsList";
import {
  ISportBetListFilterData as IAgntSportBetListFilterData
} from "../components/agent/PlayerProfile/components/SportBetList";
import {
  ICasinoBetListFilterData as IAgntCasinoBetListFilterData
} from "../components/agent/PlayerProfile/components/CasinoBetList";
import {
  ISportBetListFilterData as IAdmSportBetListFilterData
} from "../components/admin/Agents/PlayerProfile/components/SportBetList";
import {
  ICasinoBetListFilterData as IAdmCasinoBetListFilterData
} from "../components/admin/Agents/PlayerProfile/components/CasinoBetList";
import { initialFullReportFilterData } from "../components/admin/Reports/FullReport/components/DesktopReport";
import { IFullReportFilterDataType } from "../components/admin/Reports/FullReport/types";
import { IFlatFeeFilterDataType } from "../components/admin/FlatFee/types";
import { initFlatFeeFilterState } from "../components/admin/FlatFee/components/Desktop";
import {getPeriod} from "../components/admin/Reports/utils";
import { ISubAffDealsV2FilterDataType } from "../components/admin/SubAffiliateDealsV2/types";
import { initSubAffDealsV2FilterState } from "../components/admin/SubAffiliateDealsV2/components/ListSubAffDeals";
import { IWlCreatorFilterDataType } from "../components/admin/WlCreator/types";

export type OrderType = {
  [key: string]: 'asc' | 'desc'
};

export type ObjType = {
  [key: string]: any;
};

//admin partners
const initialDealTrackersOrder: OrderType = { created: "desc" };
const initialPartnersOrder: OrderType = { id: "asc" };
export const initialPartnersFilter: IFilterData = {
  approve_status: {id: 'approved', label: 'approved'},
  communication_statuses: [],
  traffic_statuses: [],
  traffic_sources: [],
  traffic_geos: [],
  affiliate_ids: [],
  manager_ids: [],
  manager_teams: [],
  platform_ids: [],
  is_blocked: null,
  is_email_confirmed: true,
  order: { id: "asc" },
  invitation_link_ids: [],
  invitation_manager_ids: [],
  min_balance_amount: '',
  max_balance_amount: '',
  has_multi_account: null,
  tagIds: [],
  subAffLevels: [],
  subAffDeals: [],
  hasReferralProgram: null,
  parentAffiliateIds: [],
};

//admin creatives
export const initialAdmCreativesFilter = {
  status: null,
  product: null,
  concept: null,
  geo: [],
  language: [],
  platforms: [],
  brands: [],
  type: [],
};
export const initialAdmCreativesOrder: OrderType = { id: "desc" };
export const initialAdmCreativesV2Filter = {
  status: null,
  use_as_traffic_back: null,
  type: [],
  product: null,
  concept: null,
  geo: [],
  language: [],
  depSuccess: null,
  platforms: [],
  brands: [],
};
export const initialAdmCreativesV2Order: OrderType = { id: "desc" };

//admin deals
export const initialAdmDealsOrder: OrderType = { created_at: "desc" };
export const initialAdmAgentsListOrder: OrderType = { createdAt: "desc" };
export const initialAdmCashierListOrder: OrderType = { createdAt: "desc" };
export const initialAdmAgentsFullListOrder: OrderType = { createdAt: "desc" };
export const initialAgntAgentsListOrder: OrderType = { createdAt: "desc" };
export const initialAdmDealsFilter = {
  brands: [],
  platforms: [],
  created_by: [],
  deal_types: [],
};
export const initialAdmAgentsListFilter = {
  underAgentId: null,
  level: null,
  search: '',
  regDateFrom: '',
  regDateTo: '',
  status: [],
  type: [],
  country: [],
  roles: [],
  brands: [],
};

export const initialAdmCashierListFilter = {
  platformIds: [],
  underAgentId: null,
  level: null,
  search: '',
  regDateFrom: '',
  regDateTo: '',
  status: [],
  type: [],
  country: [],
  roles: [],
};

export const initialAdmAgentsFullListFilter = {
  underAgentId: null,
  level: null,
  search: '',
  regDateFrom: '',
  regDateTo: '',
  status: [],
  country: [],
  platformIds: [],
  roles: [],
  brands: [],
  shouldExcludeSelf: false,
};

export const initialAgntAgentsListFilter = {
  underAgentId: null,
  level: null,
  search: '',
  regDateFrom: '',
  regDateTo: '',
  status: [],
  country: [],
  roles: [],
  brands: [],
};

export const initialAgntPlayersListOrder: OrderType = { registeredAt: "desc" };
export const initialAgntPlayersListFilter = {
  regDateFrom: null,
  regDateTo: null,
  agentIds: [],
  country: [],
  brands: [],
  underAgentId: null,
};
export const initialAdmPlayersListOrder: OrderType = { registeredAt: "desc" };
export const initialAdmPlayersListFilter = {
  regDateFrom: null,
  regDateTo: null,
  agentIds: [],
  country: [],
  brands: [],
  underAgentId: null,
};

export const initialAdmFullPlayersListOrder: OrderType = { registeredAt: "desc" };
export const initialAdmFullPlayersListFilter = {
  regDateFrom: null,
  regDateTo: null,
  agentIds: [],
  country: [],
  platformIds: [],
  brands: [],
  underAgentId: null,
};

export const initialAgntTransactionsOrder: OrderType = { createdAt: "desc" };
export const initialAdmTransactionsOrder: OrderType = { createdAt: "desc" };
export const initialGlobalBetListOrder: OrderType = { acceptTime: "desc" };
export const initialWithdrawalListOrder: OrderType = { createdAt: "desc" };
export const initialAgntTransactionsListFilter = {
  period: 'last_month',
  dateFrom: getPeriod('last_month').start,
  dateTo: getPeriod('last_month').end,
  transactionType: '',
  wallet: null,
  brands: [],
};
export const initialWithdrawalListFilter = {
  dateFrom: null,
  dateTo: null,
  platformIds: [],
  brandCodes: [],
  statuses: [],
  cashierIds: [],
  currencyCodes: [],
};
export const initialGlobalBetListFilter = {
  period: 'last_7_days',
  sent_from: getPeriod('last_7_days').start,
  sent_to: getPeriod('last_7_days').end,
  brands: [],
  betTypes: [],
  betStatuses: [],
  betResults: [],
  sports: [],
  betId: '',
  playerIds: [],
  agentIds: [],
  underAgent: null,
  platformIds: [],
};
export const initialAdmTransactionsListFilter = {
  period: 'last_month',
  dateFrom: getPeriod('last_month').start,
  dateTo: getPeriod('last_month').end,
  transactionType: '',
  wallet: null,
  brands: [],
};

export const initialAgntTransfersOrder: OrderType = { createdAt: "desc" };
export const initialAgntTransfersListFilter = {
  period: 'last_month',
  dateFrom: getPeriod('last_month').start,
  dateTo: getPeriod('last_month').end,
  platformIds: [],
  from: [],
  operationType: '',
  recipientType: '',
  toAgent: [],
  toPlayer: [],
  wallet: null,
  brands: [],
};

export const initialAdmTransfersOrder: OrderType = { createdAt: "desc" };
export const initialAdmTransfersListFilter = {
  period: 'last_month',
  dateFrom: getPeriod('last_month').start,
  dateTo: getPeriod('last_month').end,
  platformIds: [],
  from: [],
  operationType: '',
  recipientType: '',
  toAgent: [],
  toPlayer: [],
  wallet: null,
  brands: [],
};

export const initialAdmAllTransfersOrder: OrderType = { createdAt: "desc" };
export const initialAdmAllTransfersListFilter = {
  period: 'last_month',
  dateFrom: getPeriod('last_month').start,
  dateTo: getPeriod('last_month').end,
  platformIds: [],
  from: [],
  operationType: '',
  recipientType: '',
  toAgent: [],
  toPlayer: [],
  wallet: null,
  brands: [],
};


//admin subAffDeals
export const initialAdmSubAffDealsOrder: OrderType = { created_at: "desc" };

//admin subAffDealsV2
export const initialAdmSubAffDealsV2Order: OrderType = { createdAt: "desc" };
export const initialAdmSubAffDealsV2Filter: ISubAffDealsV2FilterDataType = initSubAffDealsV2FilterState;

//admin offers
export const initialAdmOffersFilter = {
  brands: [],
  geo: [],
};
export const initialAdmOffersOrder: OrderType = { id: "desc" };

//admin details FinReport
export const initialAdmDetailsFinReportFilter: IFilterFields = {
  affiliateIds: [],
  managerIds: [],
  departmentIds: [],
  statuses: [],
  currencies: [],
  brands: [],
  paymentMethodNames: [],
  companies: [],
  tagIds: [],
};

//admin FinReport
export const initialAdmFinReportFilter: IFilterFieldsFinance = {
  affiliateIds: [],
  managerIds: [],
  departmentIds: [],
  platformIds: [],
  statuses: [],
  paymentMethodNames: [],
  companies: [],
};

//aff offers
export const initialAffOffersFilter = {
  geo: [],
};

//brands
export const initialBrandsFilter = {
  countries: [],
  currencies: [],
  departments: [],
  operator_ids: [],
};
export const initialBrandsOrder: OrderType = { created_at: "desc" };

//admWebhooksReport
export const initialAdmWebhooksReportFilter: IWebhookReportFilterData = initialFilterData;
export const initialAdmCreativesReportFilter: ICreativesReportFilterData = initialCreativesReportFilterData;

//admNewSummaryReport
export const initialAdmSummaryReportFilter: ISummaryReportFilterDataType = initialSummaryReportFilterData;
export const initialAdmAgentStatReportFilter: IAgentStatReportFilterDataType = initialAgentStatReportFilterData;
export const initialAdmCashierStatReportFilter: ICashierStatReportFilterDataType = initialCashierStatReportFilterData;
export const initialAgAgentStatReportFilter: IAgStatReportFilterDataType = initialAgStatReportFilterData;

//affNewSummaryReport
export const initialAffSummaryReportFilter: IAffSummaryReportFilterDataType = initialAffSummaryReportFilterData;

//partners tracker links / Creative list
export const initialPartnersTrackerLinksFilter: IFilterData = {
  sort_by: '',
  product: null,
  concept: null,
  geo: [],
  brands: [],
  language: [],
}

//admEmployees
export const initialAdmEmployeesOrder : OrderType = {
  id: 'desc',
}

//admEmployees
export const initialAdmFinReportOrder : OrderType = {
  period: "desc",
}

export const initialAdmDetailsFinReportOrder : OrderType = {
  affiliateId: 'asc'
}

//aff tracker links / Creative list
export const initialAffTrackerLinksFilter: IFilterData = {
  sort_by: '',
  product: null,
  concept: null,
  geo: [],
  language: [],
}

//billing filters
export const initialAdmBillingFilters: ObjType = { platform: "", date: ''};

//TwoFa settings
export const initialAdmTwoFaSettings: ObjType = { email_secret: "", email_url: ""};

//Payment History
export const initialPaymentHistoryOrder: OrderType = { date: "desc" };
export const initialAdmPaymentBreakdownOrder : OrderType = {
  id: 'desc',
};

export const initialAdmPayoutsOrder : OrderType = {
  id: 'desc',
};

export const initialAdmAdjustmentsOrder : OrderType = {
  id: 'desc',
};

export const initialAffPaymentHistoryPgOrder : OrderType = {
  period: 'desc',
};

export const initialAdmPaymentHistoryPgOrder : OrderType = {
  period: 'desc',
};

export const initialSportBetListFilter = {
  betId: '',
  betType: '',
  betResult: '',
  sportTypeKey: '',
  dateFrom: null,
  dateTo: null,
  limit: '',
  after: '',
};

export const initialCasinoBetListFilter = {
  roundId: '',
  productType: '',
  gameProviderName: '',
  gameName: '',
  dateFrom: null,
  dateTo: null,
  limit: '',
  after: '',
};

export const initialAdmCasinoBetListFilter = {
  roundId: '',
  productType: '',
  gameProviderName: '',
  gameName: '',
  dateFrom: null,
  dateTo: null,
  limit: '',
  after: '',
};

export const initialAdmSportBetListFilter = {
  betId: '',
  betType: '',
  betResult: '',
  sportTypeKey: '',
  dateFrom: null,
  dateTo: null,
  limit: '',
  after: '',
};

//fullReport
export const initialFullReportFilter: IFullReportFilterDataType = initialFullReportFilterData;

export const initialAdmFlatFeeFilter: IFlatFeeFilterDataType = initFlatFeeFilterState;
export const initialAdmFlatFeeOrder: OrderType = { id: "desc" };

//Documents
export const initialAdmDocumentsFilters: ObjType = { platform: ''};
export const initialAdmDocumentsOrder: OrderType = { updatedAt: "desc" };

//Wl Creator
export const initialAdmWlCreatorOrder: OrderType = { createdAt: "desc" };

const initialAdmWlCreatorFilter: IWlCreatorFilterDataType = {
  nameServerStatus: [],
  createdByIds: [],
};

export interface IGlobalContext {
  partnersSearch: string;
  partnersFilter: IFilterData;
  partnersOrder: OrderType;
  partnersPage: number;
  partnersRows: number;
  partnersActiveFilterTab: string,
  selectedPartners: [],
  setPartnersFilter: (filter: IFilterData) => void;
  setPartnersOrder: (order: OrderType) => void;
  setPartnersPage: (page: number) => void;
  setPartnersRows: (rows: number) => void;
  setPartnersActiveFilterTab: (tab: string) => void;
  setPartnersSearch: (search: string) => void;
  setSelectedPartners: (array: any) => void,

  dealTrackersSearch: string;
  dealTrackersOrder: OrderType;
  dealTrackersPage: number;
  dealTrackersRows: number;
  dealTrackersAffId: string;
  setDealTrackersAffId: (affId: string) => void;
  setDealTrackersSearch: (search: string) => void;
  setDealTrackersOrder: (order: OrderType) => void;
  setDealTrackersPage: (page: number) => void;
  setDealTrackersRows: (rows: number) => void;

  dealArchivedTrackersOrder: OrderType;
  dealArchivedTrackersPage: number;
  dealArchivedTrackersRows: number;
  setDealArchivedTrackersOrder: (order: OrderType) => void;
  setDealArchivedTrackersPage: (page: number) => void;
  setDealArchivedTrackersRows: (rows: number) => void;
  resetDealsState: () => void;

  //admCreatives
  admCreativesSearch: string;
  admCreativesFilter: IFilterData;
  admCreativesOrder: OrderType;
  admCreativesPage: number;
  admCreativesRows: number;
  setAdmCreativesFilter: (filter: IFilterData) => void;
  setAdmCreativesOrder: (order: OrderType) => void;
  setAdmCreativesPage: (page: number) => void;
  setAdmCreativesRows: (rows: number) => void;
  setAdmCreativesSearch: (search: string) => void;

  //admCreativesV2
  admCreativesV2Search: string;
  admCreativesV2Filter: IFilterData;
  admCreativesV2Order: OrderType;
  admCreativesV2Page: number;
  admCreativesV2Rows: number;
  setAdmCreativesV2Filter: (filter: IFilterData) => void;
  setAdmCreativesV2Order: (order: OrderType) => void;
  setAdmCreativesV2Page: (page: number) => void;
  setAdmCreativesV2Rows: (rows: number) => void;
  setAdmCreativesV2Search: (search: string) => void;
  resetAdmCreativesV2Context: () => void;

  //admDeals
  admDealsSearch: string;
  admDealsOrder: OrderType;
  admDealsPage: number;
  admDealsRows: number;
  admDealsSelectedBrands: any;
  admDealsSelectedRowBrands: any;
  admDealsFilter: IDealsFilterData;
  setAdmDealsFilter: (filter: IFilterData) => void;
  setAdmDealsOrder: (order: OrderType) => void;
  setAdmDealsPage: (page: number) => void;
  setAdmDealsRows: (rows: number) => void;
  setAdmDealsSearch: (search: string) => void;
  setAdmDealsSelectedBrands: (row: any) => void;
  setAdmDealsSelectedRowBrands: (row: any) => void;

  //admSubAffDeals
  admSubAffDealsSearch: string;
  admSubAffDealsOrder: OrderType;
  admSubAffDealsPage: number;
  admSubAffDealsRows: number;
  setAdmSubAffDealsOrder: (order: OrderType) => void;
  setAdmSubAffDealsPage: (page: number) => void;
  setAdmSubAffDealsRows: (rows: number) => void;
  setAdmSubAffDealsSearch: (search: string) => void;

	//admSubAffDealsV2
  admSubAffDealsV2Search: string;
  admSubAffDealsV2Order: OrderType;
  admSubAffDealsV2Page: number;
  admSubAffDealsV2Rows: number;
	admSubAffDealsV2Filter: ISubAffDealsV2FilterDataType;
	setAdmSubAffDealsV2Filter: (filter: ISubAffDealsV2FilterDataType) => void;
  setAdmSubAffDealsV2Order: (order: OrderType) => void;
  setAdmSubAffDealsV2Page: (page: number) => void;
  setAdmSubAffDealsV2Rows: (rows: number) => void;
  setAdmSubAffDealsV2Search: (search: string) => void;

  //admOffers
  admOffersSearch: string;
  admOffersFilter: IOffersFilterData;
  admOffersOrder: OrderType;
  admOffersPage: number;
  admOffersRows: number;
  setAdmOffersFilter: (filter: IFilterData) => void;
  setAdmOffersOrder: (order: OrderType) => void;
  setAdmOffersPage: (page: number) => void;
  setAdmOffersRows: (rows: number) => void;
  setAdmOffersSearch: (search: string) => void;

  //affOffers
  affOffersList: any[],
  affOffersSearch: string;
  affOffersFilter: IOffersFilterData,
  setAffOffersList: (data: any[]) => void;
  setAffOffersFilter: (filter: IOffersFilterData) => void;
  setAffOffersSearch: (search: string) => void;

  //affPaymentHistory
  affPaymentHistoryPgOrder: OrderType;
  affPaymentHistoryPgPage: number;
  affPaymentHistoryPgRows: number;
  setAffPaymentHistoryPgOrder: (order: OrderType) => void;
  setAffPaymentHistoryPgPage: (page: number) => void;
  setAffPaymentHistoryPgRows: (rows: number) => void;
  resetAffPaymentHistoryPgState: () => void;

  //admPaymentHistory
  admPaymentHistoryPgOrder: OrderType;
  admPaymentHistoryPgPage: number;
  admPaymentHistoryPgRows: number;
  setAdmPaymentHistoryPgOrder: (order: OrderType) => void;
  setAdmPaymentHistoryPgPage: (page: number) => void;
  setAdmPaymentHistoryPgRows: (rows: number) => void;
  resetAdmPaymentHistoryPgState: () => void;

  //Brands
  brandsSearch: string;
  brandsFilter: IOffersFilterData;
  brandsOrder: OrderType;
  brandsPage: number;
  brandsRows: number;
  setBrandsFilter: (filter: IFilterData) => void;
  setBrandsOrder: (order: OrderType) => void;
  setBrandsPage: (page: number) => void;
  setBrandsRows: (rows: number) => void;
  setBrandsSearch: (search: string) => void;

  //admWebhooksReport
  admWebhooksReportFilter: IWebhookReportFilterData;
  setAdmWebhooksReportFilter: (filter: IWebhookReportFilterData) => void;
  resetAdmWebhooksReportFilter: () => void;

  //admNewCreativesReport
  admCreativesReportFilter: ICreativesReportFilterData;
  setAdmCreativesReportFilter: (filter: ICreativesReportFilterData) => void;
  resetAdmCreativesReportFilter: () => void;

  //admNewSummaryReport
  admSummaryReportFilter: ISummaryReportFilterDataType;
  setAdmSummaryReportFilter: (filter: ISummaryReportFilterDataType) => void;
  resetAdmSummaryReportFilter: () => void;

  //admAgentStatisticReport
  admAgentStatisticReportFilter: IAgentStatReportFilterDataType;
  setAdmAgentStatisticReportFilter: (filter: IAgentStatReportFilterDataType) => void;
  resetAdmAgentStatisticReportFilter: () => void;

  //admCashierStatisticReport
  admCashierStatisticReportFilter: ICashierStatReportFilterDataType;
  setAdmCashierStatisticReportFilter: (filter: ICashierStatReportFilterDataType) => void;
  resetAdmCashierStatisticReportFilter: () => void;

  //agAgentStatisticReport
  agAgentStatisticReportFilter: IAgStatReportFilterDataType;
  setAgAgentStatisticReportFilter: (filter: IAgStatReportFilterDataType) => void;
  resetAgAgentStatisticReportFilter: () => void;

  //affNewSummaryReport
  affSummaryReportFilter: IAffSummaryReportFilterDataType;
  setAffSummaryReportFilter: (filter: IAffSummaryReportFilterDataType) => void;
  resetAffSummaryReportFilter: () => void;

  //admPartnersTrackerLinks
  admPartnersTrackerLinksDrawerFilter: IFilterData;
  setAdmPartnersTrackerLinksDrawerFilter: (filter: IFilterData) => void;
  resetAdmPartnersTrackerLinksDrawerFilter: () => void;

  //affPartnersTrackerLinks
  affTrackerLinksDrawerFilter: IFilterData;
  setAffTrackerLinksDrawerFilter: (filter: IFilterData) => void;
  resetAffTrackerLinksDrawerFilter: () => void;

  //FinReport
  admFinReportFilter: IFilterFieldsFinance,
  admFinReportPage: number,
  admFinReportRows: number,
  admFinReportOrder: OrderType,
  setAdmFinReportFilter: (filter: IFilterFieldsFinance) => void;
  setAdmFinReportPage: (page: number) => void;
  setAdmFinReportRows: (rows: number) => void;
  setAdmFinReportOrder: (order: OrderType) => void;
  resetAdmFinReportFilter: () => void;

  //detailsFinReport
  admDetailsFinReportFilter: IFilterFields,
  admDetailsFinReportSearch: string;
  admDetailsFinReportPage: number,
  admDetailsFinReportRows: number,
  admDetailsFinReportOrder: OrderType,
  setAdmDetailsFinReportFilter: (filter: IFilterFields) => void;
  setAdmDetailsFinReportSearch: (search: string) => void;
  setAdmDetailsFinReportPage: (page: number) => void;
  setAdmDetailsFinReportRows: (rows: number) => void;
  setAdmDetailsFinReportOrder: (order: OrderType) => void;
  resetAdmDetailsFinReportFilter: () => void;
  resetAdmDetailsFinReportContexts: () => void;

  //admEmployees
  admEmployeesFilter: IEmployeesFilterData;
  admEmployeesSearch: string;
  admEmployeesOrder: OrderType;
  admEmployeesPage: number;
  admEmployeesRows: number;
  setAdmEmployeesFilter: (filter: IEmployeesFilterData) => void;
  setAdmEmployeesOrder: (order: OrderType) => void;
  setAdmEmployeesPage: (page: number) => void;
  setAdmEmployeesRows: (rows: number) => void;
  setAdmEmployeesSearch: (search: string) => void;
  resetAdmEmployeeContexts: () => void;

  //admBilling
  admBillingFilters: ObjType;
  setAdmBillingFilters: (filter: ObjType) => void;
  resetAdmBillingContexts: () => void;

  //DashboardV2Filter
  dashboardV2Filter: IDashboardFilterType;
  setDashboardV2Filter: (filter: IDashboardFilterType) => void;
  resetDashboardV2Filter: () => void;

  //admPaymentHistory
  admPaymentHistoryOrder: OrderType;
  admPaymentHistoryPage: number;
  admPaymentHistoryRows: number;
  setAdmPaymentHistoryOrder: (order: OrderType) => void;
  setAdmPaymentHistoryPage: (page: number) => void;
  setAdmPaymentHistoryRows: (rows: number) => void;

  //affPaymentHistory
  affPaymentHistoryOrder: OrderType;
  affPaymentHistoryPage: number;
  affPaymentHistoryRows: number;
  setAffPaymentHistoryOrder: (order: OrderType) => void;
  setAffPaymentHistoryPage: (page: number) => void;
  setAffPaymentHistoryRows: (rows: number) => void;

  //admPaymentBreakdown
  admPaymentBreakdownOrder: OrderType;
  admPaymentBreakdownPage: number;
  admPaymentBreakdownRows: number;
  setAdmPaymentBreakdownOrder: (order: OrderType) => void;
  setAdmPaymentBreakdownPage: (page: number) => void;
  setAdmPaymentBreakdownRows: (rows: number) => void;

  //admPayouts
  admPayoutsOrder: OrderType;
  admPayoutsPage: number;
  admPayoutsRows: number;
  setAdmPayoutsOrder: (order: OrderType) => void;
  setAdmPayoutsPage: (page: number) => void;
  setAdmPayoutsRows: (rows: number) => void;

  //admAdjustments
  admAdjustmentsOrder: OrderType;
  admAdjustmentsPage: number;
  admAdjustmentsRows: number;
  setAdmAdjustmentsOrder: (order: OrderType) => void;
  setAdmAdjustmentsPage: (page: number) => void;
  setAdmAdjustmentsRows: (rows: number) => void;

  //admAffAccountSearch
  admAffAccountSearch: string;
  setAdmAffAccountSearch: (search: string) => void;

  resetContext: () => void;
  resetPartnersContext: () => void;
  resetAdmCreativesContext: () => void;
  resetAdmDealsContext: () => void;
  resetAdmSubAffDealsContext: () => void;
	resetAdmSubAffDealsV2Context: () => void;
  resetAdmOffersContext: () => void;
  resetAffOffersContext: () => void;
  resetBrandsContext: () => void;

  //admAgentsList
  admAgentsListSearch: string;
  admAgentsListOrder: OrderType;
  admAgentsListPage: number;
  admAgentsListRows: number;
  admAgentsListFilter: IAgentsListFilterData;
  setAdmAgentsListFilter: (filter: IFilterData) => void;
  setAdmAgentsListOrder: (order: OrderType) => void;
  setAdmAgentsListPage: (page: number) => void;
  setAdmAgentsListRows: (rows: number) => void;
  setAdmAgentsListSearch: (search: string) => void;
  resetAgentsListContext: () => void;

  //admCashierList
  admCashierListSearch: string;
  admCashierListOrder: OrderType;
  admCashierListPage: number;
  admCashierListRows: number;
  admCashierListFilter: IAgentsListFilterData;
  setAdmCashierListFilter: (filter: IFilterData) => void;
  setAdmCashierListOrder: (order: OrderType) => void;
  setAdmCashierListPage: (page: number) => void;
  setAdmCashierListRows: (rows: number) => void;
  setAdmCashierListSearch: (search: string) => void;
  resetCashierListContext: () => void;

  //admAgentsFullList
  admAgentsFullListSearch: string;
  admAgentsFullListOrder: OrderType;
  admAgentsFullListPage: number;
  admAgentsFullListRows: number;
  admAgentsFullListFilter: IAgentsFullListFilterData;
  setAdmAgentsFullListFilter: (filter: IFilterData) => void;
  setAdmAgentsFullListOrder: (order: OrderType) => void;
  setAdmAgentsFullListPage: (page: number) => void;
  setAdmAgentsFullListRows: (rows: number) => void;
  setAdmAgentsFullListSearch: (search: string) => void;
  resetAgentsFullListContext: () => void;

  //agntAgentsList
  agntAgentsListSearch: string;
  agntAgentsListOrder: OrderType;
  agntAgentsListPage: number;
  agntAgentsListRows: number;
  agntAgentsListFilter: IAgntAgentsListFilterData;
  setAgntAgentsListFilter: (filter: IFilterData) => void;
  setAgntAgentsListOrder: (order: OrderType) => void;
  setAgntAgentsListPage: (page: number) => void;
  setAgntAgentsListRows: (rows: number) => void;
  setAgntAgentsListSearch: (search: string) => void;
  resetAgntAgentsListContext: () => void;

  //agntPlayersList
  agntPlayersListSearch: string;
  agntPlayersListOrder: OrderType;
  agntPlayersListPage: number;
  agntPlayersListRows: number;
  agntPlayersListFilter: IAgntPlayersListFilterData;
  setAgntPlayersListFilter: (filter: IAgntPlayersListFilterData) => void;
  setAgntPlayersListOrder: (order: OrderType) => void;
  setAgntPlayersListPage: (page: number) => void;
  setAgntPlayersListRows: (rows: number) => void;
  setAgntPlayersListSearch: (search: string) => void;
  resetAgntPlayersListContext: () => void;

  //agntPlayersList
  admPlayersListSearch: string;
  admPlayersListOrder: OrderType;
  admPlayersListPage: number;
  admPlayersListRows: number;
  admPlayersListFilter: IAgntPlayersListFilterData;
  setAdmPlayersListFilter: (filter: IAgntPlayersListFilterData) => void;
  setAdmPlayersListOrder: (order: OrderType) => void;
  setAdmPlayersListPage: (page: number) => void;
  setAdmPlayersListRows: (rows: number) => void;
  setAdmPlayersListSearch: (search: string) => void;
  resetAdmPlayersListContext: () => void;

  //agntPlayersList
  admFullPlayersListSearch: string;
  admFullPlayersListOrder: OrderType;
  admFullPlayersListPage: number;
  admFullPlayersListRows: number;
  admFullPlayersListFilter: IAgntPlayersListFilterData;
  setAdmFullPlayersListFilter: (filter: IAgntPlayersListFilterData) => void;
  setAdmFullPlayersListOrder: (order: OrderType) => void;
  setAdmFullPlayersListPage: (page: number) => void;
  setAdmFullPlayersListRows: (rows: number) => void;
  setAdmFullPlayersListSearch: (search: string) => void;
  resetAdmFullPlayersListContext: () => void;

  //agnt Transactions List
  agntTransactionsListSearch: string;
  agntTransactionsListOrder: OrderType;
  agntTransactionsListPage: number;
  agntTransactionsListRows: number;
  agntTransactionsListFilter: IAgntTransactionsFilterData;
  setAgntTransactionsListFilter: (filter: IAgntTransactionsFilterData) => void;
  setAgntTransactionsListOrder: (order: OrderType) => void;
  setAgntTransactionsListPage: (page: number) => void;
  setAgntTransactionsListRows: (rows: number) => void;
  setAgntTransactionsListSearch: (search: string) => void;
  resetAgntTransactionsListContext: () => void;

  //Withdrawal List
  withdrawalListSearch: string;
  withdrawalListOrder: OrderType;
  withdrawalListPage: number;
  withdrawalListRows: number;
  withdrawalListFilter: IWithdrawalFilterData;
  setWithdrawalListFilter: (filter: IWithdrawalFilterData) => void;
  setWithdrawalListOrder: (order: OrderType) => void;
  setWithdrawalListPage: (page: number) => void;
  setWithdrawalListRows: (rows: number) => void;
  setWithdrawalListSearch: (search: string) => void;
  resetWithdrawalListContext: () => void;

  //Global Bet List
  globalBetListSearch: string;
  globalBetListOrder: OrderType;
  globalBetListPage: number;
  globalBetListRows: number;
  globalBetListFilter: any;
  setGlobalBetListFilter: (filter: any) => void;
  setGlobalBetListOrder: (order: OrderType) => void;
  setGlobalBetListPage: (page: number) => void;
  setGlobalBetListRows: (rows: number) => void;
  setGlobalBetListSearch: (search: string) => void;
  resetGlobalBetListContext: () => void;

  //agntTransfersList
  agntTransfersListSearch: string;
  agntTransfersListOrder: OrderType;
  agntTransfersListPage: number;
  agntTransfersListRows: number;
  agntTransfersListFilter: IAgntTransfersFilterData;
  setAgntTransfersListFilter: (filter: IAgntTransfersFilterData) => void;
  setAgntTransfersListOrder: (order: OrderType) => void;
  setAgntTransfersListPage: (page: number) => void;
  setAgntTransfersListRows: (rows: number) => void;
  setAgntTransfersListSearch: (search: string) => void;
  resetAgntTransfersListContext: () => void;

  //adm Transactions List
  admTransactionsListSearch: string;
  admTransactionsListOrder: OrderType;
  admTransactionsListPage: number;
  admTransactionsListRows: number;
  admTransactionsListFilter: IAdmTransactionsFilterData;
  setAdmTransactionsListFilter: (filter: IAdmTransactionsFilterData) => void;
  setAdmTransactionsListOrder: (order: OrderType) => void;
  setAdmTransactionsListPage: (page: number) => void;
  setAdmTransactionsListRows: (rows: number) => void;
  setAdmTransactionsListSearch: (search: string) => void;
  resetAdmTransactionsListContext: () => void;

  //admTransfersList
  admTransfersListSearch: string;
  admTransfersListOrder: OrderType;
  admTransfersListPage: number;
  admTransfersListRows: number;
  admTransfersListFilter: IAdmTransfersFilterData;
  setAdmTransfersListFilter: (filter: IAdmTransfersFilterData) => void;
  setAdmTransfersListOrder: (order: OrderType) => void;
  setAdmTransfersListPage: (page: number) => void;
  setAdmTransfersListRows: (rows: number) => void;
  setAdmTransfersListSearch: (search: string) => void;
  resetAdmTransfersListContext: () => void;

  //agntSportBetList
  agntSportBetListSearch: string;
  agntSportBetListPage: number;
  agntSportBetListRows: number;
  agntSportBetListFilter: IAgntSportBetListFilterData;
  setAgntSportBetListFilter: (filter: IAgntSportBetListFilterData) => void;
  setAgntSportBetListPage: (page: number) => void;
  setAgntSportBetListRows: (rows: number) => void;
  setAgntSportBetListSearch: (search: string) => void;
  resetAgntSportBetListContext: () => void;

  //agntCasinoBetList
  agntCasinoBetListSearch: string;
  agntCasinoBetListPage: number;
  agntCasinoBetListRows: number;
  agntCasinoBetListFilter: IAgntCasinoBetListFilterData;
  setAgntCasinoBetListFilter: (filter: IAgntCasinoBetListFilterData) => void;
  setAgntCasinoBetListPage: (page: number) => void;
  setAgntCasinoBetListRows: (rows: number) => void;
  setAgntCasinoBetListSearch: (search: string) => void;
  resetAgntCasinoBetListContext: () => void;

  //admSportBetList
  admSportBetListSearch: string;
  admSportBetListPage: number;
  admSportBetListRows: number;
  admSportBetListFilter: IAdmSportBetListFilterData;
  setAdmSportBetListFilter: (filter: IAdmSportBetListFilterData) => void;
  setAdmSportBetListPage: (page: number) => void;
  setAdmSportBetListRows: (rows: number) => void;
  setAdmSportBetListSearch: (search: string) => void;
  resetAdmSportBetListContext: () => void;

  //admCasinoBetList
  admCasinoBetListSearch: string;
  admCasinoBetListPage: number;
  admCasinoBetListRows: number;
  admCasinoBetListFilter: IAdmCasinoBetListFilterData;
  setAdmCasinoBetListFilter: (filter: IAdmCasinoBetListFilterData) => void;
  setAdmCasinoBetListPage: (page: number) => void;
  setAdmCasinoBetListRows: (rows: number) => void;
  setAdmCasinoBetListSearch: (search: string) => void;
  resetAdmCasinoBetListContext: () => void;

  //admAllTransfersList
  admAllTransfersListSearch: string;
  admAllTransfersListOrder: OrderType;
  admAllTransfersListPage: number;
  admAllTransfersListRows: number;
  admAllTransfersListFilter: IAdmTransfersFilterData;
  setAdmAllTransfersListFilter: (filter: IAdmTransfersFilterData) => void;
  setAdmAllTransfersListOrder: (order: OrderType) => void;
  setAdmAllTransfersListPage: (page: number) => void;
  setAdmAllTransfersListRows: (rows: number) => void;
  setAdmAllTransfersListSearch: (search: string) => void;
  resetAdmAllTransfersListContext: () => void;

  //fullReport
  fullReportFilter: IFullReportFilterDataType;
  setFullReportFilter: (filter: IFullReportFilterDataType) => void;
  resetFullReportFilter: () => void;

	//admFlatFee
	admFlatFeeSearch: string;
	admFlatFeeFilter: IFlatFeeFilterDataType;
	admFlatFeeOrder: OrderType;
	admFlatFeePage: number;
	admFlatFeeRows: number;
	setAdmFlatFeeFilter: (filter: IFlatFeeFilterDataType) => void;
	setAdmFlatFeeOrder: (order: OrderType) => void;
	setAdmFlatFeePage: (page: number) => void;
	setAdmFlatFeeRows: (rows: number) => void;
	setAdmFlatFeeSearch: (search: string) => void;
	resetAdmFlatFeeContext: () => void;

  //admDocuments
	admDocumentsFilters: ObjType;
	admDocumentsOrder: OrderType;
	admDocumentsPage: number;
	admDocumentsRows: number;
	setAdmDocumentsFilters: (filter: ObjType) => void;
	setAdmDocumentsOrder: (order: OrderType) => void;
	setAdmDocumentsPage: (page: number) => void;
	setAdmDocumentsRows: (rows: number) => void;
	resetAdmDocumentsContext: () => void;

  //admWlCreator
  admWlCreatorSearch: string;
  admWlCreatorFilter: IWlCreatorFilterDataType;
  admWlCreatorOrder: OrderType;
  admWlCreatorPage: number;
  admWlCreatorRows: number;
  setAdmWlCreatorFilter: (filter: IWlCreatorFilterDataType) => void;
  setAdmWlCreatorOrder: (order: OrderType) => void;
  setAdmWlCreatorPage: (page: number) => void;
  setAdmWlCreatorRows: (rows: number) => void;
  setAdmWlCreatorSearch: (search: string) => void;
  resetAdmWlCreatorContext: () => void;
}

export const initialValue: IGlobalContext = {
  partnersSearch: '',
  partnersFilter: initialPartnersFilter,
  partnersOrder: initialPartnersOrder,
  partnersPage: 0,
  partnersRows: 10,
  partnersActiveFilterTab: '2',
  selectedPartners: [],
  setPartnersFilter: function (filter) {
    this.partnersFilter = filter;
  },
  setPartnersActiveFilterTab: function (tab) {
    this.partnersActiveFilterTab = tab;
  },
  setPartnersOrder: function (newOrder) {
    this.partnersOrder = newOrder;
  },
  setPartnersPage: function (page) {
    this.partnersPage = page;
  },
  setPartnersRows: function (rows) {
    this.partnersRows = rows;
  },
  setPartnersSearch: function (search) {
    this.partnersSearch = search;
  },
  setSelectedPartners: function (array) {
    this.selectedPartners = array;
  },

  dealTrackersSearch: '',
  dealTrackersOrder: initialDealTrackersOrder,
  dealTrackersPage: 0,
  dealTrackersRows: 10,
  dealTrackersAffId: '',
  setDealTrackersAffId: function (affId) {
    this.dealTrackersAffId = affId;
  },
  setDealTrackersSearch: function (search) {
    this.dealTrackersSearch = search;
  },
  setDealTrackersOrder: function (newOrder) {
    this.dealTrackersOrder = newOrder;
  },
  setDealTrackersPage: function (page) {
    this.dealTrackersPage = page;
  },
  setDealTrackersRows: function (rows) {
    this.dealTrackersRows = rows;
  },

  dealArchivedTrackersOrder: initialDealTrackersOrder,
  dealArchivedTrackersPage: 0,
  dealArchivedTrackersRows: 10,
  setDealArchivedTrackersOrder: function (newOrder) {
    this.dealArchivedTrackersOrder = newOrder;
  },
  setDealArchivedTrackersPage: function (page) {
    this.dealArchivedTrackersPage = page;
  },
  setDealArchivedTrackersRows: function (rows) {
    this.dealArchivedTrackersRows = rows;
  },
  resetDealsState: function () {
    this.dealTrackersSearch = '';
    this.dealTrackersOrder = initialDealTrackersOrder;
    this.dealTrackersPage = 0;
    this.dealTrackersRows = 10;
    this.dealArchivedTrackersOrder = initialDealTrackersOrder;
    this.dealArchivedTrackersPage = 0;
    this.dealArchivedTrackersRows = 10;
  },

  //admCreatives
  admCreativesSearch: '',
  admCreativesFilter: initialAdmCreativesFilter,
  admCreativesOrder: initialAdmCreativesOrder,
  admCreativesPage: 0,
  admCreativesRows: 10,
  setAdmCreativesFilter: function (filter) {
    this.admCreativesFilter = filter;
  },
  setAdmCreativesOrder: function (newOrder) {
    this.admCreativesOrder = newOrder;
  },
  setAdmCreativesPage: function (page) {
    this.admCreativesPage = page;
  },
  setAdmCreativesRows: function (rows) {
    this.admCreativesRows = rows;
  },
  setAdmCreativesSearch: function (search) {
    this.admCreativesSearch = search;
  },

  //admCreativesV2
  admCreativesV2Search: '',
  admCreativesV2Filter: initialAdmCreativesV2Filter,
  admCreativesV2Order: initialAdmCreativesV2Order,
  admCreativesV2Page: 0,
  admCreativesV2Rows: 10,
  setAdmCreativesV2Filter: function (filter) {
    this.admCreativesV2Filter = filter;
  },
  setAdmCreativesV2Order: function (newOrder) {
    this.admCreativesV2Order = newOrder;
  },
  setAdmCreativesV2Page: function (page) {
    this.admCreativesV2Page = page;
  },
  setAdmCreativesV2Rows: function (rows) {
    this.admCreativesV2Rows = rows;
  },
  setAdmCreativesV2Search: function (search) {
    this.admCreativesV2Search = search;
  },

  //admDeals
  admDealsSearch: '',
  admDealsOrder: initialAdmDealsOrder,
  admDealsPage: 0,
  admDealsRows: 10,
  admDealsFilter: initialAdmDealsFilter,
  admDealsSelectedBrands: [],
  admDealsSelectedRowBrands: [],
  setAdmDealsOrder: function (newOrder) {
    this.admDealsOrder = newOrder;
  },
  setAdmDealsPage: function (page) {
    this.admDealsPage = page;
  },
  setAdmDealsRows: function (rows) {
    this.admDealsRows = rows;
  },
  setAdmDealsSearch: function (search) {
    this.admDealsSearch = search;
  },
  setAdmDealsSelectedBrands: function (selected) {
    this.admDealsSelectedBrands = selected;
  },
  setAdmDealsSelectedRowBrands: function (selected) {
    this.admDealsSelectedRowBrands = selected;
  },
  setAdmDealsFilter: function (filter) {
    this.admDealsFilter = filter;
  },

  //admSubAffDeals
  admSubAffDealsSearch: '',
  admSubAffDealsOrder: initialAdmSubAffDealsOrder,
  admSubAffDealsPage: 0,
  admSubAffDealsRows: 10,
  setAdmSubAffDealsOrder: function (newOrder) {
    this.admSubAffDealsOrder = newOrder;
  },
  setAdmSubAffDealsPage: function (page) {
    this.admSubAffDealsPage = page;
  },
  setAdmSubAffDealsRows: function (rows) {
    this.admSubAffDealsRows = rows;
  },
  setAdmSubAffDealsSearch: function (search) {
    this.admSubAffDealsSearch = search;
  },

	//admSubAffDealsV2
  admSubAffDealsV2Search: '',
  admSubAffDealsV2Order: initialAdmSubAffDealsV2Order,
  admSubAffDealsV2Page: 0,
  admSubAffDealsV2Rows: 10,
	admSubAffDealsV2Filter: initialAdmSubAffDealsV2Filter,
	setAdmSubAffDealsV2Filter: function (filter) {
		this.admSubAffDealsV2Filter = filter;
	},
  setAdmSubAffDealsV2Order: function (newOrder) {
    this.admSubAffDealsOrder = newOrder;
  },
  setAdmSubAffDealsV2Page: function (page) {
    this.admSubAffDealsPage = page;
  },
  setAdmSubAffDealsV2Rows: function (rows) {
    this.admSubAffDealsRows = rows;
  },
  setAdmSubAffDealsV2Search: function (search) {
    this.admSubAffDealsSearch = search;
  },

  //admOffers
  admOffersSearch: '',
  admOffersFilter: initialAdmOffersFilter,
  admOffersOrder: initialAdmOffersOrder,
  admOffersPage: 0,
  admOffersRows: 10,
  setAdmOffersFilter: function (filter) {
    this.admOffersFilter = filter;
  },
  setAdmOffersOrder: function (newOrder) {
    this.admOffersOrder = newOrder;
  },
  setAdmOffersPage: function (page) {
    this.admOffersPage = page;
  },
  setAdmOffersRows: function (rows) {
    this.admOffersRows = rows;
  },
  setAdmOffersSearch: function (search) {
    this.admOffersSearch = search;
  },

  //affOffers
  affOffersList: [],
  affOffersSearch: '',
  affOffersFilter: initialAffOffersFilter,
  setAffOffersList: function (data) {
    this.affOffersList = data;
  },
  setAffOffersFilter: function (filter) {
    this.affOffersFilter = filter;
  },
  setAffOffersSearch: function (search) {
    this.affOffersSearch = search;
  },

  //Brands
  brandsSearch: '',
  brandsFilter: initialBrandsFilter,
  brandsOrder: initialBrandsOrder,
  brandsPage: 0,
  brandsRows: 10,
  setBrandsFilter: function (filter) {
    this.brandsFilter = filter;
  },
  setBrandsOrder: function (newOrder) {
    this.brandsOrder = newOrder;
  },
  setBrandsPage: function (page) {
    this.brandsPage = page;
  },
  setBrandsRows: function (rows) {
    this.brandsRows = rows;
  },
  setBrandsSearch: function (search) {
    this.brandsSearch = search;
  },

  //admWebhooksReport
  admWebhooksReportFilter: initialAdmWebhooksReportFilter,
  setAdmWebhooksReportFilter: function (filter) {
    this.admWebhooksReportFilter = filter;
  },
  resetAdmWebhooksReportFilter: function () {
    this.admWebhooksReportFilter = initialAdmWebhooksReportFilter;
  },

  //admCreativesReport
  admCreativesReportFilter: initialAdmCreativesReportFilter,
  setAdmCreativesReportFilter: function (filter) {
    this.admCreativesReportFilter = filter;
  },
  resetAdmCreativesReportFilter: function () {
    this.admCreativesReportFilter = initialAdmCreativesReportFilter;
  },

  //admSummaryReport
  admSummaryReportFilter: initialAdmSummaryReportFilter,
  setAdmSummaryReportFilter: function (filter) {
    this.admSummaryReportFilter = filter;
  },
  resetAdmSummaryReportFilter: function () {
    this.admSummaryReportFilter = initialAdmSummaryReportFilter;
  },

  //admAgentStatisticReport
  admAgentStatisticReportFilter: initialAdmAgentStatReportFilter,
  setAdmAgentStatisticReportFilter: function (filter) {
    this.admAgentStatisticReportFilter = filter;
  },
  resetAdmAgentStatisticReportFilter: function () {
    this.admAgentStatisticReportFilter = initialAdmAgentStatReportFilter;
  },
  //admCashierStatisticReport
  admCashierStatisticReportFilter: initialAdmCashierStatReportFilter,
  setAdmCashierStatisticReportFilter: function (filter) {
    this.admCashierStatisticReportFilter = filter;
  },
  resetAdmCashierStatisticReportFilter: function () {
    this.admCashierStatisticReportFilter = initialAdmCashierStatReportFilter;
  },
  //agAgentStatisticReport
  agAgentStatisticReportFilter: initialAgAgentStatReportFilter,
  setAgAgentStatisticReportFilter: function (filter) {
    this.agAgentStatisticReportFilter = filter;
  },
  resetAgAgentStatisticReportFilter: function () {
    this.agAgentStatisticReportFilter = initialAgAgentStatReportFilter;
  },

  //admPartnersTrackerLinks
  admPartnersTrackerLinksDrawerFilter: initialPartnersTrackerLinksFilter,
  setAdmPartnersTrackerLinksDrawerFilter: function (filter) {
    this.admPartnersTrackerLinksDrawerFilter = filter;
  },
  resetAdmPartnersTrackerLinksDrawerFilter: function () {
    this.admPartnersTrackerLinksDrawerFilter = initialPartnersTrackerLinksFilter;
  },

  //affSummaryReport
  affSummaryReportFilter: initialAffSummaryReportFilter,
  setAffSummaryReportFilter: function (filter) {
    this.affSummaryReportFilter = filter;
  },
  resetAffSummaryReportFilter: function () {
    this.affSummaryReportFilter = initialAffSummaryReportFilter;
  },

  //affTrackerLinks
  affTrackerLinksDrawerFilter: initialAffTrackerLinksFilter,
  setAffTrackerLinksDrawerFilter: function (filter) {
    this.affTrackerLinksDrawerFilter = filter;
  },
  resetAffTrackerLinksDrawerFilter: function () {
    this.admPartnersTrackerLinksDrawerFilter = initialAffTrackerLinksFilter;
  },

  //admDetailsFinReport
  admDetailsFinReportFilter: initialAdmDetailsFinReportFilter,
  admDetailsFinReportSearch: '',
  admDetailsFinReportOrder: initialAdmDetailsFinReportOrder,
  admDetailsFinReportPage: 0,
  admDetailsFinReportRows: 10,
  setAdmDetailsFinReportFilter: function (filter) {
    this.admDetailsFinReportFilter = filter;
  },
  resetAdmDetailsFinReportFilter: function () {
    this.admDetailsFinReportFilter = initialAdmDetailsFinReportFilter;
  },
  setAdmDetailsFinReportOrder: function (newOrder) {
    this.admDetailsFinReportOrder = newOrder;
  },
  setAdmDetailsFinReportSearch: function (search) {
    this.admDetailsFinReportSearch = search;
  },
  setAdmDetailsFinReportPage: function (page) {
    this.admDetailsFinReportPage = page;
  },
  setAdmDetailsFinReportRows: function (rows) {
    this.admDetailsFinReportRows = rows;
  },
  resetAdmDetailsFinReportContexts: function () {
    this.admDetailsFinReportFilter = initialAdmDetailsFinReportFilter;
    this.admDetailsFinReportOrder = initialAdmDetailsFinReportOrder;
    this.admDetailsFinReportPage = 0;
    this.admDetailsFinReportRows = 10;
    this.admDetailsFinReportSearch = '';
  },

  //admFinReport
  admFinReportFilter: initialAdmFinReportFilter,
  admFinReportOrder: initialAdmFinReportOrder,
  admFinReportPage: 0,
  admFinReportRows: 10,
  setAdmFinReportFilter: function (filter) {
    this.admFinReportFilter = filter;
  },
  resetAdmFinReportFilter: function () {
    this.admFinReportFilter = initialAdmFinReportFilter;
  },
  setAdmFinReportOrder: function (newOrder) {
    this.admFinReportOrder = newOrder;
  },
  setAdmFinReportPage: function (page) {
    this.admFinReportPage = page;
  },
  setAdmFinReportRows: function (rows) {
    this.admFinReportRows = rows;
  },

  //admEmployees
  admEmployeesFilter: initialEmployeesFilterData,
  admEmployeesSearch: '',
  admEmployeesOrder: initialAdmEmployeesOrder,
  admEmployeesPage: 0,
  admEmployeesRows: 10,
  setAdmEmployeesFilter: function (filter) {
    this.admEmployeesFilter = filter;
  },
  setAdmEmployeesSearch: function (search) {
    this.admEmployeesSearch = search;
  },
  setAdmEmployeesOrder: function (newOrder) {
    this.admEmployeesOrder = newOrder;
  },
  setAdmEmployeesPage: function (page) {
    this.admEmployeesPage = page;
  },
  setAdmEmployeesRows: function (rows) {
    this.admEmployeesRows = rows;
  },

  //admBilling
  admBillingFilters: initialAdmBillingFilters,
  setAdmBillingFilters: function (filter) {
    this.admBillingFilters = filter;
  },
  resetAdmBillingContexts: function () {
    localStorage.removeItem('billing_platform');
    this.admBillingFilters = initialAdmBillingFilters;
  },

  //DashboardV2Filter
  dashboardV2Filter: initialDashboardV2FilterData,
  setDashboardV2Filter: function (filter) {
    this.dashboardV2Filter = filter;
  },
  resetDashboardV2Filter: function () {
    this.dashboardV2Filter = initialDashboardV2FilterData;
  },

  //admPaymentHistory
  admPaymentHistoryOrder: initialPaymentHistoryOrder,
  admPaymentHistoryPage: 0,
  admPaymentHistoryRows: 10,
  setAdmPaymentHistoryOrder: function (newOrder) {
    this.admPaymentHistoryOrder = newOrder;
  },
  setAdmPaymentHistoryPage: function (page) {
    this.admPaymentHistoryPage = page;
  },
  setAdmPaymentHistoryRows: function (rows) {
    this.admPaymentHistoryRows = rows;
  },

  //affPaymentHistory
  affPaymentHistoryOrder: initialPaymentHistoryOrder,
  affPaymentHistoryPage: 0,
  affPaymentHistoryRows: 10,
  setAffPaymentHistoryOrder: function (newOrder) {
    this.affPaymentHistoryOrder = newOrder;
  },
  setAffPaymentHistoryPage: function (page) {
    this.affPaymentHistoryPage = page;
  },
  setAffPaymentHistoryRows: function (rows) {
    this.affPaymentHistoryRows = rows;
  },

  //admPaymentBreakdown
  admPaymentBreakdownOrder: initialAdmPaymentBreakdownOrder,
  admPaymentBreakdownPage: 0,
  admPaymentBreakdownRows: 100,
  setAdmPaymentBreakdownOrder: function (order) {
    this.admPaymentBreakdownOrder = order;
  },
  setAdmPaymentBreakdownPage: function  (page) {
    this.admPaymentBreakdownPage = page;
  },
  setAdmPaymentBreakdownRows: function (rows) {
    this.admPaymentBreakdownRows = rows;
  },

  //admPayouts
  admPayoutsOrder: initialAdmPayoutsOrder,
  admPayoutsPage: 0,
  admPayoutsRows: 100,
  setAdmPayoutsOrder: function (order) {
    this.admPayoutsOrder = order;
  },
  setAdmPayoutsPage: function  (page) {
    this.admPayoutsPage = page;
  },
  setAdmPayoutsRows: function (rows) {
    this.admPayoutsRows = rows;
  },

  //admAdjustments
  admAdjustmentsOrder: initialAdmAdjustmentsOrder,
  admAdjustmentsPage: 0,
  admAdjustmentsRows: 100,
  setAdmAdjustmentsOrder: function (order) {
    this.admAdjustmentsOrder = order;
  },
  setAdmAdjustmentsPage: function  (page) {
    this.admAdjustmentsPage = page;
  },
  setAdmAdjustmentsRows: function (rows) {
    this.admAdjustmentsRows = rows;
  },

  //affPaymentHistory
  affPaymentHistoryPgOrder: initialAffPaymentHistoryPgOrder,
  affPaymentHistoryPgPage: 0,
  affPaymentHistoryPgRows: 10,
  setAffPaymentHistoryPgOrder: function (order) {
    this.affPaymentHistoryPgOrder = order;
  },
  setAffPaymentHistoryPgPage: function (page) {
    this.affPaymentHistoryPgPage = page;
  },
  setAffPaymentHistoryPgRows: function (rows) {
    this.affPaymentHistoryPgRows = rows;
  },
  resetAffPaymentHistoryPgState: function () {
    this.affPaymentHistoryPgOrder = initialAffPaymentHistoryPgOrder;
    this.affPaymentHistoryPgPage = 0;
    this.affPaymentHistoryPgRows = 10;
  },

  //admPaymentHistory
  admPaymentHistoryPgOrder: initialAdmPaymentHistoryPgOrder,
  admPaymentHistoryPgPage: 0,
  admPaymentHistoryPgRows: 10,
  setAdmPaymentHistoryPgOrder: function (order) {
    this.admPaymentHistoryPgOrder = order;
  },
  setAdmPaymentHistoryPgPage: function (page) {
    this.admPaymentHistoryPgPage = page;
  },
  setAdmPaymentHistoryPgRows: function (rows) {
    this.admPaymentHistoryPgRows = rows;
  },
  resetAdmPaymentHistoryPgState: function () {
    this.admPaymentHistoryPgOrder = initialAdmPaymentHistoryPgOrder;
    this.admPaymentHistoryPgPage = 0;
    this.admPaymentHistoryPgRows = 10;
  },

  //admAffAccountSearch
  admAffAccountSearch: '',
  setAdmAffAccountSearch: function (search: string) {
    this.admAffAccountSearch = search;
  },

  resetContext: function () {
    this.partnersSearch = '';
    this.partnersFilter = initialPartnersFilter;
    this.partnersOrder = initialPartnersOrder;
    this.partnersPage = 0;
    this.partnersRows = 10;
    this.partnersActiveFilterTab = '2';
    this.dealTrackersSearch = '';
    this.dealTrackersOrder = initialDealTrackersOrder;
    this.dealTrackersPage = 0;
    this.dealTrackersRows = 10;
    this.dealArchivedTrackersOrder = initialDealTrackersOrder;
    this.dealArchivedTrackersPage = 0;
    this.dealArchivedTrackersRows = 10;
    this.dashboardV2Filter = initialDashboardV2FilterData;
  },

  resetPartnersContext: function () {
    this.partnersSearch = '';
    this.partnersFilter = initialPartnersFilter;
    this.partnersOrder = initialPartnersOrder;
    this.partnersPage = 0;
    this.partnersRows = 10;
    this.partnersActiveFilterTab = '2';
    this.dealTrackersSearch = '';
    this.dealTrackersOrder = initialDealTrackersOrder;
    this.dealTrackersPage = 0;
    this.dealTrackersRows = 10;
    this.dealArchivedTrackersOrder = initialDealTrackersOrder;
    this.dealArchivedTrackersPage = 0;
    this.dealArchivedTrackersRows = 10;
  },

  resetAdmCreativesContext: function () {
    this.admCreativesSearch = '';
    this.admCreativesFilter = initialAdmCreativesFilter;
    this.admCreativesOrder = initialAdmCreativesOrder;
    this.admCreativesPage = 0;
    this.admCreativesRows = 10;
  },

  resetAdmCreativesV2Context: function () {
    this.admCreativesV2Search = '';
    this.admCreativesV2Filter = initialAdmCreativesV2Filter;
    this.admCreativesV2Order = initialAdmCreativesV2Order;
    this.admCreativesV2Page = 0;
    this.admCreativesV2Rows = 10;
  },

  resetAdmDealsContext: function () {
    this.admDealsSearch = '';
    this.admDealsOrder = initialAdmDealsOrder;
    this.admDealsPage = 0;
    this.admDealsRows = 10;
    this.admDealsSelectedBrands = [];
    this.admDealsSelectedRowBrands = [];
    this.admDealsFilter = initialAdmDealsFilter;
  },

  resetAdmSubAffDealsContext: function () {
    this.admSubAffDealsSearch = '';
    this.admSubAffDealsOrder = initialAdmSubAffDealsOrder;
    this.admSubAffDealsPage = 0;
    this.admSubAffDealsRows = 10;
  },

	resetAdmSubAffDealsV2Context: function () {
    this.admSubAffDealsV2Search = '';
    this.admSubAffDealsV2Order = initialAdmSubAffDealsV2Order;
    this.admSubAffDealsV2Page = 0;
    this.admSubAffDealsV2Rows = 10;
		this.admSubAffDealsV2Filter = initialAdmSubAffDealsV2Filter;
  },

  resetAdmOffersContext: function () {
    this.admOffersSearch = '';
    this.admOffersOrder = initialAdmOffersOrder;
    this.admOffersFilter = initialAdmOffersFilter;
    this.admOffersPage = 0;
    this.admOffersRows = 10;
  },

  resetAffOffersContext: function () {
    this.affOffersSearch = '';
    this.affOffersFilter = initialAdmOffersFilter;
    this.affOffersList = [];
  },

  resetBrandsContext: function () {
    this.brandsFilter = initialBrandsFilter;
    this.brandsSearch = '';
    this.brandsOrder = initialBrandsOrder;
    this.brandsPage = 0;
    this.brandsRows = 10;
  },

  resetAdmEmployeeContexts: function () {
    this.admEmployeesSearch = '';
    this.admEmployeesOrder = initialAdmEmployeesOrder;
    this.admEmployeesPage = 0;
    this.admEmployeesRows = 10;
  },

  //admAgents
  admAgentsListSearch: '',
  admAgentsListOrder: initialAdmAgentsListOrder,
  admAgentsListPage: 0,
  admAgentsListRows: 10,
  admAgentsListFilter: initialAdmAgentsListFilter,
  resetAgentsListContext: function () {
    this.admAgentsListSearch = '';
    this.admAgentsListOrder = initialAdmAgentsListOrder;
    this.admAgentsListPage = 0;
    this.admAgentsListRows = 10;
    this.admAgentsListFilter = initialAdmAgentsListFilter;
  },
  setAdmAgentsListOrder: function (newOrder) {
    this.admAgentsListOrder = newOrder;
  },
  setAdmAgentsListPage: function (page) {
    this.admAgentsListPage = page;
  },
  setAdmAgentsListRows: function (rows) {
    this.admAgentsListRows = rows;
  },
  setAdmAgentsListSearch: function (search) {
    this.admAgentsListSearch = search;
  },
  setAdmAgentsListFilter: function (filter) {
    this.admAgentsListFilter = filter;
  },

  //admCashier
  admCashierListSearch: '',
  admCashierListOrder: initialAdmCashierListOrder,
  admCashierListPage: 0,
  admCashierListRows: 10,
  admCashierListFilter: initialAdmCashierListFilter,
  resetCashierListContext: function () {
    this.admCashierListSearch = '';
    this.admCashierListOrder = initialAdmCashierListOrder;
    this.admCashierListPage = 0;
    this.admCashierListRows = 10;
    this.admCashierListFilter = initialAdmCashierListFilter;
  },
  setAdmCashierListOrder: function (newOrder) {
    this.admCashierListOrder = newOrder;
  },
  setAdmCashierListPage: function (page) {
    this.admCashierListPage = page;
  },
  setAdmCashierListRows: function (rows) {
    this.admCashierListRows = rows;
  },
  setAdmCashierListSearch: function (search) {
    this.admCashierListSearch = search;
  },
  setAdmCashierListFilter: function (filter) {
    this.admCashierListFilter = filter;
  },

  //admAgentsFull
  admAgentsFullListSearch: '',
  admAgentsFullListOrder: initialAdmAgentsFullListOrder,
  admAgentsFullListPage: 0,
  admAgentsFullListRows: 10,
  admAgentsFullListFilter: initialAdmAgentsFullListFilter,
  resetAgentsFullListContext: function () {
    this.admAgentsFullListSearch = '';
    this.admAgentsFullListOrder = initialAdmAgentsFullListOrder;
    this.admAgentsFullListPage = 0;
    this.admAgentsFullListRows = 10;
    this.admAgentsFullListFilter = initialAdmAgentsFullListFilter;
  },
  setAdmAgentsFullListOrder: function (newOrder) {
    this.admAgentsFullListOrder = newOrder;
  },
  setAdmAgentsFullListPage: function (page) {
    this.admAgentsFullListPage = page;
  },
  setAdmAgentsFullListRows: function (rows) {
    this.admAgentsFullListRows = rows;
  },
  setAdmAgentsFullListSearch: function (search) {
    this.admAgentsFullListSearch = search;
  },
  setAdmAgentsFullListFilter: function (filter) {
    this.admAgentsFullListFilter = filter;
  },

  //agntAgents
  agntAgentsListSearch: '',
  agntAgentsListOrder: initialAgntAgentsListOrder,
  agntAgentsListPage: 0,
  agntAgentsListRows: 10,
  agntAgentsListFilter: initialAgntAgentsListFilter,
  resetAgntAgentsListContext: function () {
    this.agntAgentsListSearch = '';
    this.agntAgentsListOrder = initialAgntAgentsListOrder;
    this.agntAgentsListPage = 0;
    this.agntAgentsListRows = 10;
    this.agntAgentsListFilter = initialAgntAgentsListFilter;
  },
  setAgntAgentsListOrder: function (newOrder) {
    this.agntAgentsListOrder = newOrder;
  },
  setAgntAgentsListPage: function (page) {
    this.agntAgentsListPage = page;
  },
  setAgntAgentsListRows: function (rows) {
    this.agntAgentsListRows = rows;
  },
  setAgntAgentsListSearch: function (search) {
    this.agntAgentsListSearch = search;
  },
  setAgntAgentsListFilter: function (filter) {
    this.agntAgentsListFilter = filter;
  },

  // Agent Players List
  agntPlayersListSearch: '',
  agntPlayersListOrder: initialAgntPlayersListOrder,
  agntPlayersListPage: 0,
  agntPlayersListRows: 10,
  agntPlayersListFilter: initialAgntPlayersListFilter,
  resetAgntPlayersListContext: function () {
    this.agntPlayersListSearch = '';
    this.agntPlayersListOrder = initialAgntPlayersListOrder;
    this.agntPlayersListPage = 0;
    this.agntPlayersListRows = 10;
    this.agntPlayersListFilter = initialAgntPlayersListFilter;
  },
  setAgntPlayersListOrder: function (newOrder) {
    this.agntPlayersListOrder = newOrder;
  },
  setAgntPlayersListPage: function (page) {
    this.agntPlayersListPage = page;
  },
  setAgntPlayersListRows: function (rows) {
    this.agntPlayersListRows = rows;
  },
  setAgntPlayersListSearch: function (search) {
    this.agntPlayersListSearch = search;
  },
  setAgntPlayersListFilter: function (filter) {
    this.agntPlayersListFilter = filter;
  },

  // Admin Players List
  admPlayersListSearch: '',
  admPlayersListOrder: initialAdmPlayersListOrder,
  admPlayersListPage: 0,
  admPlayersListRows: 10,
  admPlayersListFilter: initialAdmPlayersListFilter,
  resetAdmPlayersListContext: function () {
    this.admPlayersListSearch = '';
    this.admPlayersListOrder = initialAdmPlayersListOrder;
    this.admPlayersListPage = 0;
    this.admPlayersListRows = 10;
    this.admPlayersListFilter = initialAdmPlayersListFilter;
  },
  setAdmPlayersListOrder: function (newOrder) {
    this.admPlayersListOrder = newOrder;
  },
  setAdmPlayersListPage: function (page) {
    this.admPlayersListPage = page;
  },
  setAdmPlayersListRows: function (rows) {
    this.admPlayersListRows = rows;
  },
  setAdmPlayersListSearch: function (search) {
    this.admPlayersListSearch = search;
  },
  setAdmPlayersListFilter: function (filter) {
    this.admPlayersListFilter = filter;
  },

  // Admin Full Players List
  admFullPlayersListSearch: '',
  admFullPlayersListOrder: initialAdmFullPlayersListOrder,
  admFullPlayersListPage: 0,
  admFullPlayersListRows: 10,
  admFullPlayersListFilter: initialAdmFullPlayersListFilter,
  resetAdmFullPlayersListContext: function () {
    this.admFullPlayersListSearch = '';
    this.admFullPlayersListOrder = initialAdmFullPlayersListOrder;
    this.admFullPlayersListPage = 0;
    this.admFullPlayersListRows = 10;
    this.admFullPlayersListFilter = initialAdmFullPlayersListFilter;
  },
  setAdmFullPlayersListOrder: function (newOrder) {
    this.admFullPlayersListOrder = newOrder;
  },
  setAdmFullPlayersListPage: function (page) {
    this.admFullPlayersListPage = page;
  },
  setAdmFullPlayersListRows: function (rows) {
    this.admFullPlayersListRows = rows;
  },
  setAdmFullPlayersListSearch: function (search) {
    this.admFullPlayersListSearch = search;
  },
  setAdmFullPlayersListFilter: function (filter) {
    this.admFullPlayersListFilter = filter;
  },

  // Agent Transactions List
  agntTransactionsListSearch: '',
  agntTransactionsListOrder: initialAgntTransactionsOrder,
  agntTransactionsListPage: 0,
  agntTransactionsListRows: 10,
  agntTransactionsListFilter: initialAgntTransactionsListFilter,
  resetAgntTransactionsListContext: function () {
    this.agntTransactionsListSearch = '';
    this.agntTransactionsListOrder = initialAgntTransactionsOrder;
    this.agntTransactionsListPage = 0;
    this.agntTransactionsListRows = 10;
    this.agntTransactionsListFilter = initialAgntTransactionsListFilter;
  },
  setAgntTransactionsListOrder: function (newOrder) {
    this.agntTransactionsListOrder = newOrder;
  },
  setAgntTransactionsListPage: function (page) {
    this.agntTransactionsListPage = page;
  },
  setAgntTransactionsListRows: function (rows) {
    this.agntTransactionsListRows = rows;
  },
  setAgntTransactionsListSearch: function (search) {
    this.agntTransactionsListSearch = search;
  },
  setAgntTransactionsListFilter: function (filter) {
    this.agntTransactionsListFilter = filter;
  },

  // Withdrawal List
  withdrawalListSearch: '',
  withdrawalListOrder: initialWithdrawalListOrder,
  withdrawalListPage: 0,
  withdrawalListRows: 10,
  withdrawalListFilter: initialWithdrawalListFilter,
  resetWithdrawalListContext: function () {
    this.withdrawalListSearch = '';
    this.withdrawalListOrder = initialWithdrawalListOrder;
    this.withdrawalListPage = 0;
    this.withdrawalListRows = 10;
    this.withdrawalListFilter = initialWithdrawalListFilter;
  },
  setWithdrawalListOrder: function (newOrder) {
    this.withdrawalListOrder = newOrder;
  },
  setWithdrawalListPage: function (page) {
    this.withdrawalListPage = page;
  },
  setWithdrawalListRows: function (rows) {
    this.withdrawalListRows = rows;
  },
  setWithdrawalListSearch: function (search) {
    this.withdrawalListSearch = search;
  },
  setWithdrawalListFilter: function (filter) {
    this.withdrawalListFilter = filter;
  },

  // Global Bet List
  globalBetListSearch: '',
  globalBetListOrder: initialGlobalBetListOrder,
  globalBetListPage: 0,
  globalBetListRows: 10,
  globalBetListFilter: initialGlobalBetListFilter,
  resetGlobalBetListContext: function () {
    this.globalBetListSearch = '';
    this.globalBetListOrder = initialGlobalBetListOrder;
    this.globalBetListPage = 0;
    this.globalBetListRows = 10;
    this.globalBetListFilter = initialGlobalBetListFilter;
  },
  setGlobalBetListOrder: function (newOrder) {
    this.globalBetListOrder = newOrder;
  },
  setGlobalBetListPage: function (page) {
    this.globalBetListPage = page;
  },
  setGlobalBetListRows: function (rows) {
    this.globalBetListRows = rows;
  },
  setGlobalBetListSearch: function (search) {
    this.globalBetListSearch = search;
  },
  setGlobalBetListFilter: function (filter) {
    this.globalBetListFilter = filter;
  },

  // Agent Transfers List
  agntTransfersListSearch: '',
  agntTransfersListOrder: initialAgntTransfersOrder,
  agntTransfersListPage: 0,
  agntTransfersListRows: 10,
  agntTransfersListFilter: initialAgntTransfersListFilter,
  resetAgntTransfersListContext: function () {
    this.agntTransfersListSearch = '';
    this.agntTransfersListOrder = initialAgntTransfersOrder;
    this.agntTransfersListPage = 0;
    this.agntTransfersListRows = 10;
    this.agntTransfersListFilter = initialAgntTransfersListFilter;
  },
  setAgntTransfersListOrder: function (newOrder) {
    this.agntTransfersListOrder = newOrder;
  },
  setAgntTransfersListPage: function (page) {
    this.agntTransfersListPage = page;
  },
  setAgntTransfersListRows: function (rows) {
    this.agntTransfersListRows = rows;
  },
  setAgntTransfersListSearch: function (search) {
    this.agntTransfersListSearch = search;
  },
  setAgntTransfersListFilter: function (filter) {
    this.agntTransfersListFilter = filter;
  },

  // Agent Transactions List
  admTransactionsListSearch: '',
  admTransactionsListOrder: initialAdmTransactionsOrder,
  admTransactionsListPage: 0,
  admTransactionsListRows: 10,
  admTransactionsListFilter: initialAdmTransactionsListFilter,
  resetAdmTransactionsListContext: function () {
    this.admTransactionsListSearch = '';
    this.admTransactionsListOrder = initialAdmTransactionsOrder;
    this.admTransactionsListPage = 0;
    this.admTransactionsListRows = 10;
    this.admTransactionsListFilter = initialAdmTransactionsListFilter;
  },
  setAdmTransactionsListOrder: function (newOrder) {
    this.admTransactionsListOrder = newOrder;
  },
  setAdmTransactionsListPage: function (page) {
    this.admTransactionsListPage = page;
  },
  setAdmTransactionsListRows: function (rows) {
    this.admTransactionsListRows = rows;
  },
  setAdmTransactionsListSearch: function (search) {
    this.admTransactionsListSearch = search;
  },
  setAdmTransactionsListFilter: function (filter) {
    this.admTransactionsListFilter = filter;
  },

  // Admin Agent Transfers List
  admTransfersListSearch: '',
  admTransfersListOrder: initialAdmTransfersOrder,
  admTransfersListPage: 0,
  admTransfersListRows: 10,
  admTransfersListFilter: initialAdmTransfersListFilter,
  resetAdmTransfersListContext: function () {
    this.admTransfersListSearch = '';
    this.admTransfersListOrder = initialAdmTransfersOrder;
    this.admTransfersListPage = 0;
    this.admTransfersListRows = 10;
    this.admTransfersListFilter = initialAdmTransfersListFilter;
  },
  setAdmTransfersListOrder: function (newOrder) {
    this.admTransfersListOrder = newOrder;
  },
  setAdmTransfersListPage: function (page) {
    this.admTransfersListPage = page;
  },
  setAdmTransfersListRows: function (rows) {
    this.admTransfersListRows = rows;
  },
  setAdmTransfersListSearch: function (search) {
    this.admTransfersListSearch = search;
  },
  setAdmTransfersListFilter: function (filter) {
    this.admTransfersListFilter = filter;
  },

  // Agent SportBet List
  agntSportBetListSearch: '',
  agntSportBetListPage: 0,
  agntSportBetListRows: 25,
  agntSportBetListFilter: initialSportBetListFilter,
  resetAgntSportBetListContext: function () {
    this.agntSportBetListSearch = '';
    this.agntSportBetListPage = 0;
    this.agntSportBetListRows = 25;
    this.agntSportBetListFilter = initialSportBetListFilter;
  },
  setAgntSportBetListPage: function (page) {
    this.agntSportBetListPage = page;
  },
  setAgntSportBetListRows: function (rows) {
    this.agntSportBetListRows = rows;
  },
  setAgntSportBetListSearch: function (search) {
    this.agntSportBetListSearch = search;
  },
  setAgntSportBetListFilter: function (filter) {
    this.agntSportBetListFilter = filter;
  },

  // Agent CasinoBet List
  agntCasinoBetListSearch: '',
  agntCasinoBetListPage: 0,
  agntCasinoBetListRows: 25,
  agntCasinoBetListFilter: initialCasinoBetListFilter,
  resetAgntCasinoBetListContext: function () {
    this.agntCasinoBetListSearch = '';
    this.agntCasinoBetListPage = 0;
    this.agntCasinoBetListRows = 25;
    this.agntCasinoBetListFilter = initialCasinoBetListFilter;
  },
  setAgntCasinoBetListPage: function (page) {
    this.agntCasinoBetListPage = page;
  },
  setAgntCasinoBetListRows: function (rows) {
    this.agntCasinoBetListRows = rows;
  },
  setAgntCasinoBetListSearch: function (search) {
    this.agntCasinoBetListSearch = search;
  },
  setAgntCasinoBetListFilter: function (filter) {
    this.agntCasinoBetListFilter = filter;
  },

  // Admin SportBet List
  admSportBetListSearch: '',
  admSportBetListPage: 0,
  admSportBetListRows: 25,
  admSportBetListFilter: initialAdmSportBetListFilter,
  resetAdmSportBetListContext: function () {
    this.admSportBetListSearch = '';
    this.admSportBetListPage = 0;
    this.admSportBetListRows = 25;
    this.admSportBetListFilter = initialAdmSportBetListFilter;
  },
  setAdmSportBetListPage: function (page) {
    this.admSportBetListPage = page;
  },
  setAdmSportBetListRows: function (rows) {
    this.admSportBetListRows = rows;
  },
  setAdmSportBetListSearch: function (search) {
    this.admSportBetListSearch = search;
  },
  setAdmSportBetListFilter: function (filter) {
    this.admSportBetListFilter = filter;
  },

  // Admin CasinoBet List
  admCasinoBetListSearch: '',
  admCasinoBetListPage: 0,
  admCasinoBetListRows: 25,
  admCasinoBetListFilter: initialAdmCasinoBetListFilter,
  resetAdmCasinoBetListContext: function () {
    this.admCasinoBetListSearch = '';
    this.admCasinoBetListPage = 0;
    this.admCasinoBetListRows = 25;
    this.admCasinoBetListFilter = initialAdmCasinoBetListFilter;
  },
  setAdmCasinoBetListPage: function (page) {
    this.admCasinoBetListPage = page;
  },
  setAdmCasinoBetListRows: function (rows) {
    this.admCasinoBetListRows = rows;
  },
  setAdmCasinoBetListSearch: function (search) {
    this.admCasinoBetListSearch = search;
  },
  setAdmCasinoBetListFilter: function (filter) {
    this.admCasinoBetListFilter = filter;
  },

  // Admin Agent All Transfers List
  admAllTransfersListSearch: '',
  admAllTransfersListOrder: initialAdmAllTransfersOrder,
  admAllTransfersListPage: 0,
  admAllTransfersListRows: 10,
  admAllTransfersListFilter: initialAdmAllTransfersListFilter,
  resetAdmAllTransfersListContext: function () {
    this.admAllTransfersListSearch = '';
    this.admAllTransfersListOrder = initialAdmAllTransfersOrder;
    this.admAllTransfersListPage = 0;
    this.admAllTransfersListRows = 10;
    this.admAllTransfersListFilter = initialAdmAllTransfersListFilter;
  },
  setAdmAllTransfersListOrder: function (newOrder) {
    this.admAllTransfersListOrder = newOrder;
  },
  setAdmAllTransfersListPage: function (page) {
    this.admAllTransfersListPage = page;
  },
  setAdmAllTransfersListRows: function (rows) {
    this.admAllTransfersListRows = rows;
  },
  setAdmAllTransfersListSearch: function (search) {
    this.admAllTransfersListSearch = search;
  },
  setAdmAllTransfersListFilter: function (filter) {
    this.admAllTransfersListFilter = filter;
  },

  //fullReport
  fullReportFilter: initialFullReportFilter,
  setFullReportFilter: function (filter) {
    this.fullReportFilter = filter;
  },
  resetFullReportFilter: function () {
    this.fullReportFilter = initialFullReportFilter;
  },

	//admFlatFee
	admFlatFeeSearch: '',
	admFlatFeeFilter: initialAdmFlatFeeFilter,
	admFlatFeeOrder: initialAdmFlatFeeOrder,
	admFlatFeePage: 0,
	admFlatFeeRows: 10,
	setAdmFlatFeeFilter: function (filter) {
		this.admFlatFeeFilter = filter;
	},
	setAdmFlatFeeOrder: function (newOrder) {
		this.admFlatFeeOrder = newOrder;
	},
	setAdmFlatFeePage: function (page) {
		this.admFlatFeePage = page;
	},
	setAdmFlatFeeRows: function (rows) {
		this.admFlatFeeRows = rows;
	},
	setAdmFlatFeeSearch: function (search) {
		this.admFlatFeeSearch = search;
	},
	resetAdmFlatFeeContext: function () {
		this.admFlatFeeSearch = '';
		this.admFlatFeeFilter = initialAdmFlatFeeFilter;
		this.admFlatFeeOrder = initialAdmFlatFeeOrder;
		this.admFlatFeePage = 0;
		this.admFlatFeeRows = 10;
	},

  //admDocuments
	admDocumentsFilters: initialAdmDocumentsFilters,
	admDocumentsOrder: initialAdmDocumentsOrder,
	admDocumentsPage: 0,
	admDocumentsRows: 10,
	setAdmDocumentsFilters: function (filter) {
		this.admDocumentsFilters = filter;
	},
  setAdmDocumentsOrder: function (newOrder) {
		this.admDocumentsOrder = newOrder;
	},
	setAdmDocumentsPage: function (page) {
		this.admDocumentsPage = page;
	},
	setAdmDocumentsRows: function (rows) {
		this.admDocumentsRows = rows;
	},
	resetAdmDocumentsContext: function () {
		this.admDocumentsFilters = initialAdmDocumentsFilters;
		this.admDocumentsOrder = initialAdmDocumentsOrder;
		this.admDocumentsPage = 0;
		this.admDocumentsRows = 10;
	},

  //admWlCreator
  admWlCreatorSearch: '',
  admWlCreatorFilter: initialAdmWlCreatorFilter,
  admWlCreatorOrder: initialAdmWlCreatorOrder,
  admWlCreatorPage: 0,
  admWlCreatorRows: 10,
  setAdmWlCreatorFilter: function (filter) {
    this.admWlCreatorFilter = filter;
  },
  setAdmWlCreatorOrder: function (newOrder) {
    this.admWlCreatorOrder = newOrder;
  },
  setAdmWlCreatorPage: function (page) {
    this.admWlCreatorPage = page;
  },
  setAdmWlCreatorRows: function (rows) {
    this.admWlCreatorRows = rows;
  },
  setAdmWlCreatorSearch: function (search) {
    this.admWlCreatorSearch = search;
  },
  resetAdmWlCreatorContext: function () {
    this.admWlCreatorSearch = '';
    this.admWlCreatorFilter = initialAdmWlCreatorFilter;
    this.admWlCreatorOrder = initialAdmWlCreatorOrder;
    this.admWlCreatorPage = 0;
    this.admWlCreatorRows = 10;
  },
};

export const GlobalContext = createContext<IGlobalContext>(initialValue);
